module.exports = __webpack_public_path__ + "static/media/star.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/star.svg
// module id = 530
// module chunks = 0